namespace SP.Data {
    export class Waybill {

        private static waybillInfo: { [waybillId: string]: WaybillInfo } = {};

        static async getWaybillInfo(waybillId: number, useCache = true): Promise<WaybillInfo> {
            let result = null;
            if (useCache) result = this.waybillInfo[waybillId];

            if (result == null) {
                var response = await SP.get<any>("/api/v1/info/waybillInfo/" + waybillId);
                if (response.status != 200) await SP.alertX(response.status + ": " + response.msg);
                result = response.data;
                if (response.status == 200 && useCache) this.waybillInfo[waybillId] = result;
            }
            return result;
        }

        //static async getWaybillInfos(): Promise<SP.WaybillInfo[]> {
        //    var response = await SP.get<any>("/api/v1/info/waybillInfos");
        //    if (response.status != 200) await SP.alertX(response.status + ": " + response.msg);
        //    return response.data;
        //}

    }
}